import { Component } from '@angular/core';

@Component({
    selector: 'app-warning-banner',
    templateUrl: './warning-banner.component.html',
    styleUrls: ['./warning-banner.component.scss'],
    standalone: false
})
export class WarningBannerComponent {
  constructor() {}
}
